export { };
export const defaults = {
	app: {
		applicationId: 'myvehicles',
		pageEditorClass: 'is-page-editor',
		generalErrorCodes: [] as {
			code: string,
			message: string
		}[],
		validatorRules: {
			rules: {
				Autotitel: {
					maxlength: 255
				},
				Marke: {
					maxlength: 255,
					noemojis: true,
					required: true
				},
				Baureihe: {
					maxlength: 255,
					noemojis: true
				},
				Modell: {
					maxlength: 255,
					noemojis: true
				},
				Karosserievariante: {
					maxlength: 128
				},
				DeutschesKennzeichen: {
					numberplatecross: ["plate_1", "plate_2", "plate_3"]
				}
			}
		},
		validationmessages: {
			client: {
				Autotitel: {
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein."
				},
				Marke: {
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein.",
					noemojis: "Bitte geben Sie eine gültige Marke ein.",
					required: "Sie haben keine Marke angegeben. Bitte korrigieren Sie ihre Eingabe!"
				},
				Baureihe: {
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein.",
					noemojis: "Bitte geben Sie eine gültige Baureihe ein."
				},
				Modell: {
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein.",
					noemojis: "Bitte geben Sie ein gültiges Modell ein."
				},
				Karosserievariante: {
					maxlength: "Bitte geben Sie maximal {0} Zeichen ein."
				},
				DeutschesKennzeichen: {
					numberplatecross: "Bitte füllen Sie das Kennzeichen vollständig aus."
				}
			},
			backend: {}
		}
	}
};